import GenericTooltip from '~/common/components/GenericTooltip';
import Text from '~/common/components/Texts/Text';

import ConditionEvaluator from './utilityComponents/ConditionEvaluator';
import ContentWrapper from './utilityComponents/ContentWrapper';
import ProcessedText from './utilityComponents/ProcessedText';

type HelperTextProps = {
  placeholders?: any[];
  infoToolTip?: string;
  text?: string;
  name?: string;
  conditions?: any;
  hasBottomBorder?: boolean;
  hasTopBorder?: boolean;
  padding?: string;
  metadata?: { index: number };
};

/**
 * @typedef {object} HelperTextProps
 * @property {string} text - The text to display.
 * @property {import('./../types/common').ElementPlaceholder[]} placeholders - The placeholders to replace in the text.
 * @property {string} infoToolTip - The tooltip text.
 * @property {string} name - The name of the component.
 * @property {import{'./../types/common'}.ElementCondition} condition - The condition object.
 * @property {boolean} hasBottomBorder - The flag to show the bottom border.
 * @param {HelperTextProps} props
 * @returns {JSX.Element}
 */
export default function HelperText({
  text,
  placeholders,
  infoToolTip,
  name,
  conditions,
  hasBottomBorder = false,
  hasTopBorder = false,
  padding = '1rem 0rem',
  metadata,
  ...rest
}: Readonly<HelperTextProps>) {
  return (
    <ConditionEvaluator conditions={conditions}>
      <ContentWrapper
        hasTopBorder={hasTopBorder}
        hasBottomBorder={hasBottomBorder}
        padding={padding}
      >
        <Text as="p" padding={padding} {...rest}>
          <ProcessedText
            metadata={metadata}
            text={text}
            name={name}
            placeholders={placeholders}
          />
          {infoToolTip && <GenericTooltip label={infoToolTip} />}
        </Text>
      </ContentWrapper>
    </ConditionEvaluator>
  );
}
